export default __webpack_public_path__ + "static/media/ask.b3c6a802.jpg";